'use strict';

require('../../style/index.css');

require('./index.css');

require('../../radio/style/css');

require('../../checkbox/style/css');

require('../../dropdown/style/css');

require('../../spin/style/css');

require('../../pagination/style/css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/table/style/css.js
// module id = 1015
// module chunks = 0